
<div class="main-container">
    <div class="close-btn-container" (click)="close()">
        <img src="../../assets/icons/close.svg" alt="Close Icon" class="close-icon">
    </div>
    <div class="vc-pin-close-container">
        <div class="header-container-new-vc-pin">
            <span><img src="../../assets/icons/virtual_consultant_pin.png" alt="New Pin Icon" class="new-vc-pin-header-icon"> </span>
            <h1 mat-dialog-title  class="new-vc-pin-header">{{ 'NEW-PIN-TYPE-DIALOG.VIRTUAL-CONSULTANT-TITLE' | translate }}</h1>
        </div>
    </div>

    <div class="vc-pin-info-container">

        <div class="vc-pin-container">
            <div class="vc-pin-headers">
                <p class="vc-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.DATE-TIME' | translate }}:</p>
                <p class="vc-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.LATITUDE' | translate }}:</p>
                <p class="vc-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.LONGITUDE' | translate }}:</p>
                <p class="vc-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.FARM' | translate }}:</p>
                <p class="vc-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.FIELD' | translate }}:</p>
                <p class="vc-pin-header-text">{{'NEW-PIN-TYPE-DIALOG.CREATED-BY' | translate }}:</p>
            </div>

        </div>

        <div class="vc-pin-container">
            <ng-container>
                <p class="vc-pin-info-text">{{pinObj.date ? dayjs(pinObj.date).format(dateStringFormatting) : placeholder}}</p>
                <p class="vc-pin-info-text">{{pinObj.lat}}</p>
                <p class="vc-pin-info-text">{{pinObj.lng}}</p>
                <p class="vc-pin-info-text">{{pinObj.farm}}</p>
                <p class="vc-pin-info-text">{{pinObj.field}}</p>
                <p class="vc-pin-info-text">{{pinObj.creatingUser}}</p>
            </ng-container>

        </div>
    </div>

    <form [formGroup]="updatePinForm">
        <mat-form-field class="vc-pin-input" appearance="outline">
            <mat-label>{{'VIEW-SAVE-PIN-DIALOG.PIN-NAME' | translate }}</mat-label>
            <input matInput formControlName="pinDescription">
            <mat-error *ngIf="updatePinForm.get('pinDescription').invalid"  class="error-notice">
                Required* - Pin Name
            </mat-error>
        </mat-form-field>

    <div class="vc-pin-btn-container">
        <div class="vc-pin-delete-btn-container">
            <button class="delete-vc-pin-btn" mat-flat-button type="button" (click)="openDeletePinDialog()">
                <div class="vc-pin-btn-content">
                    <img src="../../assets/icons/delete.svg" alt="Delete Icon" class="new-vc-pin-btn-icon">
                    <span><p class="vc-pin-btn-text">{{ 'NEW-PIN-TYPE-DIALOG.DELETE-PIN' | translate }}</p></span>
                </div>
            </button>
        </div>

        <div class="vc-pin-update-btn-container">
            <button class="update-vc-pin-btn" mat-flat-button type="button" (click)="updatePin()">
                <div class="vc-pin-btn-content">
                    <span><p class="vc-pin-btn-text">{{ 'NEW-PIN-TYPE-DIALOG.UPDATE-PIN' | translate }}</p></span>
                </div>
            </button>
        </div>

        <div class="vc-pin-open-vc-btn-container">
            <button class="open-vc-pin-btn" mat-flat-button type="button" (click)="openVirtualConsultant()">
                <div class="vc-pin-btn-content">
                    <span><p class="vc-pin-btn-text">{{ 'NEW-PIN-TYPE-DIALOG.OPEN-VIRTUAL-CONSULTANT' | translate }}</p></span>
                </div>
            </button>
        </div>

    </div>

</form>

</div>


